export default {
  en: 'EN',
  nl: 'NL',
  no: 'NO',
};
